export default __webpack_public_path__ + "static/media/sidebarArrow.fa87fa2d.svg";